module.exports = __webpack_public_path__ + "i18n/ru.1d0961a52466b6259c5bbd2f97542799.json";